import { theme } from "../../theme";
export const noEvents = {
    message: {
      fontWeight: "bold",
      fontSize: "66px",
      color: theme.palette.grey["700"],
      lineHeight: 1,
      marginLeft: "20px",
    },
    paragraph: {
      marginTop: "10px",
      marginBottom: "20px",
    },
    mainBox:{
      minHeight: "calc(100vh - 70px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    innerDiv:{
      width:'256px',
      textAlign:'center',
    },
  } as const;